import { create } from 'zustand';

const getInitialTheme = () => {
  if (typeof window !== 'undefined') {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
  return false;
};

export const useThemeStore = create((set) => ({
  isDarkMode: getInitialTheme(),
  
  toggleTheme: () => set((state) => {
    const newIsDark = !state.isDarkMode;
    localStorage.setItem('theme', newIsDark ? 'dark' : 'light');
    return { isDarkMode: newIsDark };
  }),
  
  initializeTheme: () => set((state) => {
    // DOM initialization removed as it's now handled by ThemeSync component
    return state;
  })
}));
